import React from 'react'
import AppConfig from "../../AppConfig";
import {Panel} from "react-bootstrap";
import Link from "react-router-dom/es/Link";
import LogowanieService from "../../modules/logowanie/LogowanieService";
import loga from '../../images/logawszystkieprostokat.png'

export default class Sidebar2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded:true
        };
        this.onClickLink=this.onClickLink.bind(this)
    }

    onClickLink(obj){
        if(Boolean(obj)){
            if(obj.nazwa ==='Newsletter'){
                window.open('http://mailing.marcel-bus.pl/','_blank');
            }
        }
    }

    render() {
        return (
            <div id="ApplicationHeader"
                 style={{width: '200px'}}>
                <div id="AppHeaderTopPart">
                    <div className="collapseBtnContainer">
                            <span style={{marginLeft: '20px'}}>
                                        <span className="logo-fullname">
                                            <div id={'LOGO_CONTAINER'}>
                                                TOP eBus
                                            </div>
                                        </span>
                                        <span className="logo-fullname-version">
                                            {AppConfig.APP_VER()}<br/>{AppConfig.APP_UPDATE().substring(0,10)}
                                        </span>
                                    </span>

                    </div>
                </div>

                <div className="link-list">
                    {
                        this.props.links.map(module=>{
                            if(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(module.role))
                            return(
                                <Panel id={"collapsible-panel-links"+module.id} expanded={this.props.collapsedLinks.indexOf(module.skrot)>-1}>
                                    <Panel.Heading onClick={()=>this.props.handleClickToogleSidebar(module.skrot)}>
                                        <Panel.Title toggle>
                                            <i className={module.ikona}></i>
                                            <span>{module.nazwa}</span>
                                            <div className={'pull-right'}>
                                                <i className={'fa fa-caret-down'}></i>
                                            </div>
                                        </Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Collapse>
                                        <Panel.Body>
                                            {
                                                module.podlinki.map(link=>{
                                                    if(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(link.role))
                                                    return(
                                                        <Link to={link.url} className={(this.props.currentLink.indexOf(link.url)>-1)?'sublink currentSublink':'sublink'}
                                                              onClick={()=>{this.onClickLink(link)}}>
                                                            <span>{link.nazwa}</span>
                                                        </Link>
                                                    )
                                                })
                                            }
                                        </Panel.Body>
                                    </Panel.Collapse>
                                </Panel>
                            )
                        })
                    }
                </div>
                <div style={{display:'flex', flexDirection:'column', height:'5%'}}>
                </div>
                {/*<div style={{position:'absolute', bottom:'0', width:'200px'}}>
                    <div>
                    <img src={loga} className={'img-responsive'} />
                    </div>
                    <div style={{color:'#ddd',fontSize:'9px',fontStyle:'italic',fontWeight:'normal',textAlign:'center'}}>
                        Projekt współfinansowany z Europejskiego Funduszu Rozwoju Regionalnego w ramach poddziałania 1.4.1
                        Regionalnego Programu Operacyjnego Województwa Podkarpackiego na lata 2014 – 2020.
                    </div>
                </div>*/}
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/shared/sidebar2/Sidebar2.js